export const API_BASE_URL = 'http://api.mairuiapi.com'
export const API_LICENSE = process.env.STACK_LICENCE;

export const MAI_RUI = {
    //基础数据
    base:{
        hsltList: `/hslt/list/${API_LICENSE}`, //股票列表-沪深两市股票
        hsltNew: `/hslt/new/${API_LICENSE}`, //股票列表-沪深两市新股日历

        hszgList: `/hszg/list/${API_LICENSE}`, //指数、行业、概念列表 - 指数、行业、概念
        hszgGg: `/hszg/gg/[code]/${API_LICENSE}`, //指数、行业、概念列表 - 根据指数、行业、概念找相关股票 [code]-指数、行业、概念代码
        hszgZg: `/hszg/zg/[stock_code]/${API_LICENSE}`, //指数、行业、概念列表 - 根据股票找相关指数、行业、概念

        hsrlSsjyAll: `/hsrl/ssjy/all/${API_LICENSE}`, //实时交易-全部股票实时交易数据
        hsrlSsjyMore: `/hsstock/real/time/[stock_code]/${API_LICENSE}`, //实时交易-实时交易数据
        hsrlSsjy: `/hsrl/ssjy/[stock_code]/${API_LICENSE}`, //实时交易-实时交易数据接口
        hsrlMmwp: `/hsstock/real/five/[stock_code]/${API_LICENSE}`, //实时交易-买卖五档盘口
        hsrlZbjy: `/hsrl/zbjy/[stock_code]/${API_LICENSE}`, //实时交易-当天逐笔交易
        hsrlFscj: `/hsrl/fscj/[stock_code]/${API_LICENSE}`, //实时交易-当天分时成交
        hsrlFjcj: `/hsrl/fjcj/[stock_code]/${API_LICENSE}`, //实时交易-当天分价成交占比
        hsrlZbdd: `/hsrl/zbdd/[stock_code]/${API_LICENSE}`, //实时交易-当天逐笔大单交易

        hszbFsjy: `/hszb/fsjy/[stock_code]/[level]/${API_LICENSE}`, //最新交易数据-最新分时交易
        hszbKdj: `/hszb/kdj/[stock_code]/[level]/${API_LICENSE}`, //最新交易数据-最新分时KDJ(9,3,3)
        hszbMacd: `/hszb/macd/[stock_code]/[level]/${API_LICENSE}`, //最新交易数据-最新分时MACD
        hszbMa: `/hszb/ma/[stock_code]/[level]/${API_LICENSE}`, //最新交易数据-最新分时MA
        hszbBoll: `/hszb/boll/[stock_code]/[level]/${API_LICENSE}`, //最新交易数据-最新分时BOLL(20,2)

        hszblFsjy: `/hszbl/fsjy/[stock_code]/[level]/${API_LICENSE}`, //历史交易数据-历史分时交易
        hszbcFsjy: `/hszbc/fsjy/[stock_code]/[level]/[start_time]/[end_time]/${API_LICENSE}`, //历史交易数据-自选时段历史分时交易
        hszblKdj: `/hszbl/kdj/[stock_code]/[level]/${API_LICENSE}`, //历史交易数据-历史分时KDJ(9,3,3)
        hszbcKdj: `/hszbc/kdj/[stock_code]/[level]/[start_time]/[end_time]/${API_LICENSE}`, //历史交易数据-自选时段历史分时KDJ(9,3,3)
        hszblMacd: `/hszbl/macd/[stock_code]/[level]/${API_LICENSE}`, //历史交易数据-历史分时MACD
        hszbcMacd: `/hszbc/macd/[stock_code]/[level]/[start_time]/[end_time]/${API_LICENSE}`, //历史交易数据-自选时段历史分时MACD
        hszblMa: `/hszbl/ma/[stock_code]/[level]/${API_LICENSE}`, //历史交易数据-历史分时MA
        hszbcMa: `/hszbc/ma/[stock_code]/[level]/[start_time]/[end_time]/${API_LICENSE}`, //历史交易数据-自选时段历史分时MA
        hszblBoll: `/hszbl/boll/[stock_code]/[level]/${API_LICENSE}`, //历史交易数据-历史分时BOLL(20,2)
        hszbcBoll: `/hszbc/boll/[stock_code]/[level]/[start_time]/[end_time]/${API_LICENSE}`, //历史交易数据-自选时段历史分时BOLL(20,2)

        hscpJnfh: `/hscp/jnfh/[stock_code]/${API_LICENSE}`, //近年分红

        hsstockLatest: `/hsstock/latest/[stock_code].[stock_jys]/[level]/[cq_method]/${API_LICENSE}`,
        hsstockHistory: `/hsstock/history/[stock_code].[stock_jys]/[level]/[cq_method]/${API_LICENSE}?st=[start_time]&et=[end_time]`,
    },
    //沪深分析数据
    analyse:{
        hitcJrts: `/hitc/jrts/${API_LICENSE}`, //投资参考-今日交易提示

        hilhMrxq: `/hilh/mrxq/${API_LICENSE}`, //龙虎榜-每日详情

        hibkZjhhy: `/hibk/zjhhy/${API_LICENSE}`, //板块资金流向-证监会行业
        hibkGnbk: `/hibk/gnbk/${API_LICENSE}`, //板块资金流向-概念板块
    },
    //指数数据
    index:{
        zsAll: `/zs/all/${API_LICENSE}`, //指数列表-沪深主要指数列表接口
        zsSh: `/zs/sh/${API_LICENSE}`, //指数列表-沪市指数列表接口
        zsSz: `/zs/sz/${API_LICENSE}`, //指数列表-深市指数列表接口

        zsSssj: `/zs/sssj/[index_code]/${API_LICENSE}`, //实时数据-指数实时数据接口
        zsLsgl: `/zs/lsgl/${API_LICENSE}`, //实时数据-沪深两市上涨下跌数概览

        zsFsjy: `/zs/fsjy/[index_code]/[level]/${API_LICENSE}`, //最新技术指标-最新分时交易
        zsKdj: `/zs/kdj/[index_code]/[level]/${API_LICENSE}`, //最新技术指标-最新分时KDJ(9,3,3)
        zsMacd: `/zs/macd/[index_code]/[level]/${API_LICENSE}`, //最新技术指标-最新分时MACD
        zsMa: `/zs/ma/[index_code]/[level]/${API_LICENSE}`, //最新技术指标-最新分时MA
        zsBoll: `/zs/boll/[index_code]/[level]/${API_LICENSE}`, //最新技术指标-最新分时BOLL(20,2)

        zsHfsjy: `/zs/hfsjy/[index_code]/[level]/${API_LICENSE}`, //最新技术指标-历史分时交易
        zsHkdj: `/zs/hkdj/[index_code]/[level]/${API_LICENSE}`, //最新技术指标-历史分时KDJ(9,3,3)
        zsHmacd: `/zs/hmacd/[index_code]/[level]/${API_LICENSE}`, //最新技术指标-历史分时MACD
        zsHma: `/zs/hma/[index_code]/[level]/${API_LICENSE}`, //最新技术指标-历史分时MA
        zsHboll: `/zs/hball/[index_code]/[level]/${API_LICENSE}`, //最新技术指标-历史分时BOLL(20,2)
    }
}
